import { FileOpener } from '@capacitor-community/file-opener';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export function isShareCanceled(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /cancel/i.test(message);
}

/** Write the .ics to cache and open it with Calendar (or the system share sheet). */
export async function openIcsOnDevice(blob: Blob, filename: string): Promise<void> {
  const safeName = filename.toLowerCase().endsWith('.ics') ? filename : `${filename}.ics`;
  const path = `calendar/${safeName}`;
  await Filesystem.writeFile({
    path,
    data: await blob.text(),
    directory: Directory.Cache,
    encoding: Encoding.UTF8,
    recursive: true,
  });
  const { uri } = await Filesystem.getUri({
    path,
    directory: Directory.Cache,
  });

  try {
    await FileOpener.open({
      filePath: uri,
      contentType: 'text/calendar',
      openWithDefault: false,
    });
    return;
  } catch (error) {
    if (isShareCanceled(error)) return;
  }

  await Share.share({
    title: 'Add to Calendar',
    dialogTitle: 'Add to Calendar',
    files: [uri],
  });
}
